import React, { memo, useCallback } from 'react';

import MenuItemMui from '@mui/material/MenuItem';
import { FormControlLabelSwitch } from 'components/mui/Form/FormControl/FormControlLabelSwitch';
import Stack from '@mui/material/Stack';
import SwitchBase from 'components/mui/Form/Switch/SwitchBase';
import { SortableHandle } from 'react-sortable-hoc';

import PushPinIcon from '@mui/icons-material/PushPin';
import ReorderIcon from '@mui/icons-material/Reorder';

import { styled } from '@mui/material/styles';

const HandleIcon = styled(ReorderIcon)(() => ({
  cursor: 'ns-resize',
}));

const MenuItem = styled(MenuItemMui, { label: 'VisibilityColsDropdownItem' })(({ theme }) => ({
  '&.is-dragging': {
    border: `1px solid ${theme.palette.grey[400]}`,
    zIndex: theme.zIndex.modal,
    boxShadow: theme.shadows[4],
    cursor: 'ns-resize',
  },
}));

const HandleComponent = SortableHandle(HandleIcon);

const ColumnOption = ({ column, isPinned, checked, isDisabled, onChange }) => {
  const handleClick = useCallback(
    (e) => {
      if (!isDisabled) {
        onChange(e);
      }
    },
    [isDisabled, onChange],
  );

  return (
    <MenuItem component="div" onClick={handleClick} sx={{ backgroundColor: 'common.white' }}>
      <FormControlLabelSwitch
        checked={checked}
        control={<SwitchBase />}
        disabled={isDisabled}
        label={column.title}
        sx={{ flexGrow: 1 }}
      />
      <Stack direction="row" alignItems="center" spacing={0.5} ml="auto">
        {isPinned && <PushPinIcon sx={{ fontSize: 16 }} color="primary" />}
        <HandleComponent />
      </Stack>
    </MenuItem>
  );
};

export default memo(ColumnOption);
